import styled from 'styled-components';
import { Skeleton } from '@comeon/ui';
import { SMALLER_TERMS_HEIGHT, BIGGER_TERMS_HEIGHT, calcCarouselHeight } from './constants.js';
import { BANNER_HEIGHTS } from '../banner/config';
import breakpoint from '~/utils/style-utils';

export const CarouselContainer = styled.div`
	min-height: ${({ isTermsConditionsEnabled, heightMobile }) =>
		calcCarouselHeight({ height: heightMobile, isSmall: true, isTermsConditionsEnabled })};

	${({ isTermsConditionsEnabled, heightDesktop }) => breakpoint.lg`
		min-height: ${calcCarouselHeight({ height: heightDesktop, isSmall: false, isTermsConditionsEnabled })};
	`}
`;

const HeroCarouselSkeleton = styled.div`
	display: flex;
	flex-direction: column;
`;

const BannerSkeleton = styled(Skeleton)`
	height: ${BANNER_HEIGHTS.mobile - SMALLER_TERMS_HEIGHT}px;

	${breakpoint.lg`
		height: ${BANNER_HEIGHTS.desktop - BIGGER_TERMS_HEIGHT}px;
	`}
`;

const TermsAndConditionsSkeleton = styled(Skeleton)`
	flex-grow: 1;

	height: ${SMALLER_TERMS_HEIGHT}px;

	${breakpoint.lg`
		height: ${BIGGER_TERMS_HEIGHT}px;
	`}
`;

const CarouselSkeleton = ({ isTermsConditionsEnabled }) => (
	<HeroCarouselSkeleton>
		<BannerSkeleton />
		{isTermsConditionsEnabled && <TermsAndConditionsSkeleton />}
	</HeroCarouselSkeleton>
);

export default CarouselSkeleton;
